export class MobileMenu {
	constructor(header) {
		this.header = header;
		this.openButton = header.querySelector("[data-menu-open]");
		this.closeButton = header.querySelector("[data-menu-close]");
		this.menu = header.querySelector("[data-mobile-menu]");

		this.isOpen = false;
		this.lastFocusedElement = null;
		this.previousScrollPosition = window.scrollY;
		this.scrollTicking = false;
	}

	init() {
		if (!this.openButton || !this.closeButton || !this.menu) {
			return;
		}

		this.openButton.addEventListener("click", () => this.open());
		this.closeButton.addEventListener("click", () => this.close());

		this.menu.querySelectorAll("a").forEach((link) => {
			link.addEventListener("click", () => this.close());
		});

		document.addEventListener("keydown", (event) => {
			this.handleKeydown(event);
		});

		window.addEventListener(
			"scroll",
			() => this.requestScrollUpdate(),
			{ passive: true }
		);

		window.addEventListener("resize", () => {
			if (window.innerWidth >= 990 && this.isOpen) {
				this.close();
			}
		});
	}

	open() {
		this.lastFocusedElement = document.activeElement;
		this.isOpen = true;

		this.menu.classList.add("is-open");
		this.menu.setAttribute("aria-hidden", "false");
		this.openButton.setAttribute("aria-expanded", "true");
		document.body.classList.add("zw-menu-open");

		this.closeButton.focus();
	}

	close() {
		if (!this.isOpen) {
			return;
		}

		this.isOpen = false;

		this.menu.classList.remove("is-open");
		this.menu.setAttribute("aria-hidden", "true");
		this.openButton.setAttribute("aria-expanded", "false");
		document.body.classList.remove("zw-menu-open");

		this.lastFocusedElement?.focus();
	}

	handleKeydown(event) {
		if (!this.isOpen) {
			return;
		}

		if (event.key === "Escape") {
			event.preventDefault();
			this.close();
			return;
		}

		if (event.key !== "Tab") {
			return;
		}

		const focusableElements = Array.from(
			this.menu.querySelectorAll(
				'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
			)
		);

		if (!focusableElements.length) {
			return;
		}

		const firstElement = focusableElements[0];
		const lastElement =
			focusableElements[focusableElements.length - 1];

		if (event.shiftKey && document.activeElement === firstElement) {
			event.preventDefault();
			lastElement.focus();
		}

		if (!event.shiftKey && document.activeElement === lastElement) {
			event.preventDefault();
			firstElement.focus();
		}
	}

	requestScrollUpdate() {
		if (this.scrollTicking) {
			return;
		}

		this.scrollTicking = true;

		window.requestAnimationFrame(() => {
			this.updateHeaderVisibility();
			this.scrollTicking = false;
		});
	}

	updateHeaderVisibility() {
		if (this.isOpen) {
			return;
		}

		const currentScrollPosition = Math.max(window.scrollY, 0);
		const scrollingDown =
			currentScrollPosition > this.previousScrollPosition;

		const shouldHide =
			scrollingDown &&
			currentScrollPosition > this.header.offsetHeight;

		this.header.classList.toggle("is-hidden", shouldHide);
		this.previousScrollPosition = currentScrollPosition;
	}
}

export function initialiseMobileMenus() {
	document.querySelectorAll("[data-header]").forEach((header) => {
		const mobileMenu = new MobileMenu(header);
		mobileMenu.init();
	});
}
